import React, { createContext, useState, useContext } from "react";

const SelectedIdContext = createContext();

export const SelectedIdProvider = ({ children }) => {
    const [selectedId, setSelectedId] = useState(null);
    return (
        <SelectedIdContext.Provider value={{ selectedId, setSelectedId }}>
            {children}
        </SelectedIdContext.Provider>
    );
};

export const useDataUsuarioSelected = () => {
    return useContext(SelectedIdContext);
};
